// RecoveryAI's chat-channel reply (docs/06-ux-rules.md "Thread": "RAI
// turns, in-app/web conversation → bubble, right"; P5 D2/rendering rule —
// channel decides the style, not the author). No avatar — only guest/email
// items carry one (docs/06-ux-rules.md "Avatar rule").
import palette from 'constants/palette'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { formatShortDateTime } from 'utilities/dateFormatters'
import { THREAD_ITEM_MAX_WIDTH_PX } from '../constants'

export interface ChatMessageBubbleProps {
  side: 'left' | 'right'
  text: string
  at: string
}

const ChatMessageBubble = ({ side, text, at }: ChatMessageBubbleProps) => {
  const [css] = useStyletron()

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: side === 'right' ? 'flex-end' : 'flex-start',
        maxWidth: `${THREAD_ITEM_MAX_WIDTH_PX}px`,
        marginLeft: side === 'right' ? 'auto' : undefined,
      })}
    >
      <div
        className={css({
          // Left (guest-channel) bubbles: white card matching GuestMessage's
          // bubble (VISUAL-SPEC.md §1). Right (RAI chat) bubbles: v83's
          // `.cv-obub.cv-ai` — #e7f9f9 (= spearmint10) with a #b7ecec border;
          // spearmint20 (#D0F3F2) is the nearest token for the border.
          backgroundColor:
            side === 'right' ? palette.spearmint10 : palette.white,
          border: `1px solid ${
            side === 'right' ? palette.spearmint20 : palette.grey20
          }`,
          borderRadius: '14px',
          padding: '14px 17px',
          fontSize: '14px',
          color: palette.grey90,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        })}
      >
        {text}
      </div>
      <span
        className={css({
          fontSize: '12px',
          color: palette.grey50,
          marginTop: '4px',
        })}
      >
        {formatShortDateTime(at)}
      </span>
    </div>
  )
}

export default ChatMessageBubble
